import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/site/Logo";

function formatErr(detail) {
  if (!detail) return "Fehler. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const field = "w-full bg-slate-50 border border-slate-200 px-4 py-3 focus:outline-none focus:border-accent2 transition-colors";

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block bg-brand relative overflow-hidden grain">
        <img src="https://images.unsplash.com/photo-1775116483675-a592e6e02807?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="w-full h-full object-cover opacity-40" />
        <div className="absolute bottom-12 left-12">
          <h2 className="font-display font-black text-white text-5xl tracking-tighter leading-none">Admin<br />Bereich</h2>
          <p className="mt-4 text-white/60 max-w-xs">Verwalten Sie Projekte, Kundenstimmen und Anfragen.</p>
        </div>
      </div>
      <div className="grid place-items-center p-6">
        <div className="w-full max-w-sm">
          <Logo />
          <h1 className="mt-10 font-display font-bold text-3xl">Anmelden</h1>
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
            <div>
              <label className="text-xs uppercase tracking-widest text-slate-400">E-Mail</label>
              <input data-testid="login-email" type="email" required className={field} value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-slate-400">Passwort</label>
              <input data-testid="login-password" type="password" required className={field} value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <button data-testid="login-submit" disabled={loading}
              className="w-full bg-brand text-white font-semibold py-3.5 hover:bg-accent2 transition-colors disabled:opacity-60">
              {loading ? "…" : "Anmelden"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
